import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import "firebase/compat/messaging";
import React from "react";

// Add Brevo SDK
declare global {
  interface Window {
    Brevo?: any
  }
}

import { useUser } from "@stackframe/react";

type FirebaseContextValue={
  user?: {
    displayName: string | null;
    email: string | null;
  },
  firebase: typeof firebase;
  token?: string | null;
  loading: boolean;
}
const FirebaseContext = React.createContext<FirebaseContextValue | null>(null);

// Configure Firebase.
const firebaseConfig = {
  apiKey: "AIzaSyDGUD68J7kdsQS3LJ2JIMvrrxvw8-kIQDw",
  authDomain: "adboard-booking.firebaseapp.com",
  projectId: "adboard-booking",
  storageBucket: "adboard-booking.appspot.com",
  messagingSenderId: "821161764842",
  appId: "1:821161764842:web:e7101bc98529bbbd433493",
  measurementId: "G-QL1DTXHX79"
};

firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();

export {
  messaging
};

export function FirebaseProvider({children}: {children: React.ReactNode}){
  const user = useUser();
  return <FirebaseContext.Provider value={{
    loading:false,  
    user:user ? {
      displayName: user?.displayName,
      email: user?.primaryEmail,
    }:undefined,firebase}}>
    {children}
  </FirebaseContext.Provider>
}

export const useFirebaseContext = () => {
  const context = React.useContext(FirebaseContext);
  if(context === null){
    throw new Error('useFirebaseContext must be used within a FirebaseProvider');
  }
  return context;
}
